import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import store from './store'
import Clipboard from 'v-clipboard'

import UploadForm from '@/components/UploadForm'
import IdCheck from '@/components/IdCheck'
import ResultsForm from '@/components/ResultsForm'
import Registration from '@/components/Registration'

Vue.config.productionTip = false

const routes = [
  
  { path: '/', name: "main", component: UploadForm },
  { path: '/idcheck', component: IdCheck },
  { path: '/results', component: ResultsForm },
  { path: '/registration', component: Registration },
  {
    path: '/registrationResult/:id/',
    name: 'RegResult',
    component: () => import('@/components/RegistrationResult')
  },  
  {
    path: '/registration/finish',
    name: 'RegFinish',
    component: () => import('@/components/RegFinish'),
    
  },  
]
const router = new VueRouter({
  // mode: 'history',
  routes // сокращённая запись для `routes: routes`
})

Vue.use(VueRouter)
Vue.use(Clipboard)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
